import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import Pagination from "../../Common/Pagination/Pagination";
import { CSSTransition } from "react-transition-group";
import _ from "lodash";
import { minDate } from "../../Constants/Constants";
const GovtOrderNumberDetails = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const formRef = useRef(null);
  // console.log("rowData", rowAddData)

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };
  const toggleSearch = () => {
    setShowSearch(!showSearch); // Toggle the state to show/hide search input field
  };

  // Add a function to handle page size change
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const [filterCriteria, setfilterCriteria] = useState({
    order_number: "",
    rca_number: "",
    date: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria((prevFilterCriteria) => {
      return {
        ...prevFilterCriteria,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const getData = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/govt-dispatch/govt-order-number-query/${user_id}?skip=${currentPage}&take=${pageSize}&order_number=${encodeURIComponent(
        filterCriteria.order_number
      )}&rca_number=${encodeURIComponent(
        filterCriteria.rca_number
      )}&date=${encodeURIComponent(filterCriteria.date)}`;
    // const nonEmptyFilterCriteria = Object.fromEntries(
    //   Object.entries(filterCriteria).filter(
    //     ([key, value]) => value !== null && value !== undefined && value !== ""
    //   )
    // );
    // const options = {
    //   whereFilters: nonEmptyFilterCriteria,
    //   skip: currentPage,
    //   take: pageSize,
    // };
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };

  useEffect(() => {
    const fecthDebounced = _.debounce(getData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, filterCriteria]);
  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
  }, []);

  const deleteRow = async (id) => {
    const confirmDelete = window.confirm(
      "Do you sure you want to delete this discom details?"
    );

    if (!confirmDelete) {
      return;
    }
    let BASE_URL = SERVER_URL + `/api/discom/discom-list/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
      getData();
    } else {
      toast.error(response.message);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
          // Retain the existing filter criteria values
        };
      });
      getData();
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };

  const updateData = async (rowData) => {
    const { id, discom_name } = rowData;
    let BASE_URL = SERVER_URL + `/api/discom/discom-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        discom_name,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 150,
    },
    // {
    //   headerName: "RCA Number",
    //   field: "govtOrderDetails.govtOrders.rca_number",
    //   editable: false,
    //   minWidth: 350,
    // },
    {
      headerName: "Order Number",
      field: "order_number",
      editable: false,
      minWidth: 350,
    },
    {
      headerName: "Date",
      field: "date",
      editable: false,
      minWidth: 180,
    },
    {
      headerName: "Product Name",
      field: "govtOrderDetails.product_name",
      editable: false,
      minWidth: 180,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          {/* <button
              className="btn btn-outline-info btn-sm ml-1"
              onClick={() => addDataToModal(params.data)}
              data-toggle="modal"
              data-target="#updateModal"
            >
              <i className="mdi mdi-eye-arrow-right-outline" />
            </button> */}
          <NavLink
            className="btn btn-outline-info btn-sm ml-1"
            to={"/govt-order-dispatch/" + params.data.id}
          >
            <i className="mdi mdi-eye-arrow-right-outline" />
          </NavLink>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    editable: true,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({ order_number: "", rca_number: "", date: "" });
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Govt Order Dispatch Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          {/* <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Discom
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div> */}
          <div className="search mb-3">
            <div className="row">
              {/* <div className="col-md-3" style={{ display: "flex" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by rca number"
                  onChange={(e) =>
                    handleFilterChange("rca_number", e.target.value)
                  }
                  value={rowData.rca_number}
                />
              </div> */}
              <div className="col-md-3" style={{ display: "flex" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by order number"
                  onChange={(e) =>
                    handleFilterChange("order_number", e.target.value)
                  }
                  value={filterCriteria.order_number}
                />
              </div>
              <div className="col-md-3" style={{ display: "flex" }}>
                <input
                  type="date"
                  className="form-control"
                  placeholder="Search by order number"
                  onChange={(e) => handleFilterChange("date", e.target.value)}
                  value={filterCriteria.date}
                  min={minDate}
                />
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          {/* <AddDiscomList
            //   setimgfile={setimgfile}
            formRef={formRef}
            getData={getData}
          />
          <UpdateRateList
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
          /> */}
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default GovtOrderNumberDetails;
